module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vback7-122866978249078edb8040b0c8833340.jpg";